<!--<ion-list>
  <ion-radio-group (ngModelChange)="changedValue(value)" [(ngModel)]="value">

    <ion-item>
      <ion-label>{{question.yes}}</ion-label>
      <ion-radio color="secondary" slot="start" value="yes"></ion-radio>
    </ion-item>

    <ion-item>
      <ion-label>{{question.no}}</ion-label>
      <ion-radio color="secondary" slot="start" value="no"></ion-radio>
    </ion-item>

  </ion-radio-group>
</ion-list>-->
{{value}}